/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `DP` - DOCUMENTS_AGAINST_PAYMENT
* `LC` - LETTER_OF_CREDIT
* `TT` - TELEGRAPHIC_TRANSFER
 */
export type PaymentMethodEnum = typeof PaymentMethodEnum[keyof typeof PaymentMethodEnum];


export const PaymentMethodEnum = {
  DP: 'DP',
  LC: 'LC',
  TT: 'TT',
} as const;
